
    import {useStore} from "@/store";
    import {defineComponent, reactive, toRefs,computed, ComputedRef,
    onMounted, watch, nextTick, onBeforeUnmount, onBeforeMount} from 'vue'
    import {useRoute} from "vue-router";
    import Swiper from 'swiper';
    import 'swiper/dist/css/swiper.css';
    import photoDefect from "./photoDefect.vue";
    import  reportMsgUt from "@/util/reportMsg";

    // interface ImgItem {
    //     smallPhotoUrl: string;
    //     photoPath: string;
    //     photoIdStr: string;
    // }

    interface State {
        // imgList: ImgItem[];
        noImgCurrentDefectTxt: string;
        noImgExplain: object[];
        photoViewer: object;
        slideIndex: number;
        currentIndex: number;
        photoName: string;
        photoNameForeign: string;
        groupNum: string;
        defectList: object[];
        tabIndex: number;
        reportMsg: object;
        contentHeight: number;
    }

    export default defineComponent({
        name: "swiperComponent",
        props: {
            imgList: {
                type: Array,
                default: () => {
                    return [];
                },
            },
            initialSlide: {
                type: Number,
                default: 0,
            },
            imgListLen: {
                type: Array,
                default: () => {
                    return []
                }
            },
            tabName: {
                type: String,
                default: 'basePhoto',
            },
            noImg: {
                type: Number,
                default: 0,
            },
        },
        setup(props: any, ctx: any) {
            let state: State = reactive({
                photoViewer: {},
                slideIndex: 0,
                photoName: '',
                photoNameForeign: '',
                groupNum: '0',
                currentIndex: 1,
                defectList: [],
                tabIndex: 0,
                contentHeight: 0,
                reportMsg: {},
                noImgCurrentDefectTxt: '',
                noImgExplain: []
            })
            state.reportMsg = reportMsgUt;
            const {query} = useRoute();
            const store = useStore();
            let reportData: ComputedRef<{}> = computed<{}>(() => store.state.reportData)
            let {tabName, imgListLen, imgList, initialSlide} = toRefs(props);
            imgList = imgList.value;
            // debugger;
            if (query.noImg && query.currentIndex) {
                watch(reportData, (data: any) => {
                    // console.log(data);
                    const {checkItemModules } = data
                    let oneIndex = (query.currentIndex as any).split(',')[0];
                    let twoIndex = (query.currentIndex as any).split(',')[1];
                    let threeIndex = (query.currentIndex as any).split(',')[2];
                    let currentD = checkItemModules[oneIndex].itemList[twoIndex].itemList[threeIndex];
                    let currV = currentD.signRuleVOS.map((item) => {
                        return item.defectValue || item.congValue
                    }).join('、');
                    state.noImgCurrentDefectTxt = `${currentD.checkItemName}: ${currV}`;
                    for (let i=0;i<currentD.signRuleVOS.length;i++) {
                        if (currentD.signRuleVOS[i].explain) {
                            state.noImgExplain.push(currentD.signRuleVOS[i]);
                        }
                    }
                    // state.noImgExplain = currentD.signRuleVOS.map((item) => {
                        
                    // });

                },{immediate: true})
            }
            function urlConversion(path) {
                let reg = /^(https?:\/\/)([0-9a-z.]+)(:[0-9]+)?([/0-9a-z.]+)?(\?[0-9a-z&=]+)?(#[0-9-a-z]+)?/i
                path = path ? path.replace(reg, "https://$2$3$4$5$6") : path;
                return path
            }
            // 通过当前索引确定所在分组图片数量
            function setCurrentIndex (index) {
                let imgListLenV = imgListLen.value;
                // console.log('setCurrentIndex:', index);
                let len0 = imgListLenV[0];
                let len1 = imgListLenV[0] + imgListLenV[1];
                let len2 = len1 + imgListLenV[2];
                let len3 = len2 + imgListLenV[3];
                state.photoName = imgList[index].photoName;
                state.photoNameForeign = imgList[index].photoNameForeign;
                // console.log(`index:${index},len0:${len0},len1:${len1},len2:${len2},len3:${len3}`);
                if (index <= len0-1) {
                    state.currentIndex = index;
                    state.groupNum = imgListLenV[0];
                    state.tabIndex = 0;
                } else if (len0-1 < index && index <= len1-1) {
                    state.currentIndex = index - len0;
                    state.groupNum = imgListLenV[1];
                    state.tabIndex = 1;
                } else if (len1-1 < index && index <= len2-1) {
                    state.currentIndex = index - len1;
                    state.groupNum = imgListLenV[2];
                    state.tabIndex = 2;
                } else if (len2-1 < index && index <= len3-1) {
                    state.currentIndex = index - len2;
                    state.groupNum = imgListLenV[3];
                    state.tabIndex = 3;
                }
                // console.log('tabIndex:', state.tabIndex);
            }
            function setDefectData (index) {
                if (imgList[index].defectValue !== '正常' && imgList[index].explains && imgList[index].explains.length>0) {
                    state.defectList = imgList[index].explains;
                } else {
                    state.defectList = [];
                }
            }
            
            onBeforeMount(() => {
                nextTick(()=>{
                    // 初始化swiper
                    state.photoViewer = new Swiper('.photo_swiper-container', {
                        initialSlide: initialSlide.value,
                        direction: 'horizontal',
                        loop: false,
                        zoom: true,
                        preloadImages: false,
                        observer: true,// 修改swiper自己或子元素时，自动初始化swiper
                        observeParents: true,// 修改swiper的父元素时，自动初始化swiper
                        on: {
                            slideChange: function () {
                                // console.log('swiperComponent--slideChange,activeIndex:', this.activeIndex);
                                state.slideIndex = this.activeIndex
                                setCurrentIndex(this.activeIndex); // 通过当前索引确定所在分组图片数量
                                setDefectData(this.activeIndex);
                                // console.log('swiperComponent--state.defectList:', JSON.stringify(state.defectList));
                                
                                // state.photoName = (state.imgList[this.activeIndex] as any).remark || (state.imgList[state.slideIndex] as any).photoName;
                                // 抛出切换事件
                                let item = {
                                    index: this.activeIndex,
                                    item: imgList[this.activeIndex],
                                    // item: imgList[this.activeIndex - 1],
                                    tabIndex: state.tabIndex
                                }
                                ctx.emit('slideChange', item)
                            },
                        }
                    })
                    if (query.photoCode) {
                        for (let i=0;i< imgList.length;i++) {
                            if (imgList[i].photoIdStr === query.photoCode) {
                                state.slideIndex = i;
                                break;
                            }
                        }
                        // console.log('默认查看第',state.slideIndex,'张图片');
                    } else if (!query.photoCode && query.group === 'base' && query.photoIndex) {
                        state.slideIndex = Number(query.photoIndex);
                    } else if (query.photoIndex) {
                        let len0 = Number(imgListLen.value[0]);
                        let len1 = Number(imgListLen.value[1]);
                        let len2 = Number(imgListLen.value[2]);
                        state.slideIndex = len0+len1+len2+Number(query.photoIndex);
                    }
                    // console.log('swiper-mounted-slideIndex', state.slideIndex);
                    state.photoName = imgList[state.slideIndex].remark || imgList[state.slideIndex].photoName;
                    state.photoNameForeign = imgList[state.slideIndex].remark || imgList[state.slideIndex].photoNameForeign;
                    setCurrentIndex(state.slideIndex);
                    setDefectData(state.slideIndex);
                    // let item = {
                    //     index: state.slideIndex,
                    //     item: imgList[state.slideIndex],
                    //     // item: imgList[this.activeIndex - 1],
                    //     tabIndex: state.tabIndex
                    // }
                    // ctx.emit('slideChange', item);
                    // console.log('wwwwwwwww');
                    // setDefectData(state.slideIndex+1);
                    (state.photoViewer as any).slideTo(state.slideIndex);
                    watch(initialSlide, (data)=> {
                        (state.slideIndex as any) = data;
                        // console.log('swiper-watch-slideIndex', state.slideIndex);
                        setCurrentIndex(data);
                        (state.photoViewer as any).slideTo(data);
                    });
                    
                })
            })
            return {
                state,
                urlConversion,
                setCurrentIndex,
                setDefectData
            }
        },
        components: {
            photoDefect
        },
        mounted() {
            const photoViewr = document.getElementById('photoViewr');
            this.state.contentHeight =  photoViewr ? photoViewr.clientHeight : 0;
            // console.log((photoViewr as any).clientHeight);
            // console.log(this.state.contentHeight);
        }
    })
